// extracted by mini-css-extract-plugin
export default {"modalOverlay":"qO-z","modalContent":"rO-z","header":"sO-z","close":"tO-z"};